import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

export function Input({ className, ...props }: ComponentProps<"input">) {
  return (
    <input
      data-slot="input"
      className={cn(
        "h-[50px] w-full min-w-0 rounded-pill border border-line-strong bg-surface-sunken px-[18px]",
        "font-sans text-base text-ink placeholder:text-ink-muted",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus-ring",
        "disabled:opacity-60 aria-invalid:border-status-error",
        className,
      )}
      {...props}
    />
  );
}
